export const imageFileTypes = ['.jpg', '.jpeg', '.png', '.webp', '.tiff'];
export const fileTypes = ['.csv', '.xls'];
export const allImageFileTypes = [...imageFileTypes, '.pdf'];
export const allImageFileTypesWithDrawing = [...allImageFileTypes, '.acad', '.dwg'];
export const allImageFileTypesWithVideo = [...allImageFileTypes, '.mov', '.mp4'];
